import { render } from "./EventProperties.vue?vue&type=template&id=4225f637"
import script from "./EventProperties.vue?vue&type=script&lang=js"
export * from "./EventProperties.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jjviglio/OpenMCT/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__